import React, { useEffect, useMemo, useState } from "react";
import formatDateAndTime from "../../common/formatDateAndTime";
import fetchcity from "../../common/fetchcity";
import Cancelbooking from "./Cancelbooking";
import Initiatebooking from "./Initiatebooking";
import Summary from "./Summary";
import Customerdetails from "./Customerdetails";
import moment from "moment";
import getactions from "../../common/getactions";
import Comments from "./Comments";
import Updatedetails from "./Updatedetails";
import { BlinkBlur } from "react-loading-indicators";
import Assignsalesagent from "./Assignsalesagent";
import toast from "react-hot-toast";

const ChargesTable = ({ paymentDetailsData }) => (
  <div className="overflow-hidden rounded-lg shadow mb-8">
    <table className="w-full text-sm text-left bg-white">
      <thead className="bg-[#34495e] text-white">
        <tr>
          <th className="px-6 py-3">Description</th>
          <th className="px-6 py-3">Amount</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        <tr>
          <td className="px-6 py-3">Security Deposit</td>
          <td className="px-6 py-3">
            {paymentDetailsData?.securityDeposit || "N/A"}
          </td>
        </tr>

        {paymentDetailsData?.fareBreakUp?.map((item, idx) => (
          <tr
            key={idx}
            className={`${
              item?.value === "Total Amount" ? "bg-gray-100 font-semibold" : ""
            }`}
          >
            <td className="px-6 py-3">
              {item?.value}{" "}
              {item?.value === "Total Tariff" &&
                " ( Week day + Week End Rent )"}
            </td>
            {/* <td className="px-6 py-3">{qty}</td>
            <td className="px-6 py-3">{rate}</td> */}
            <td className="px-6 py-3">{item?.amount || "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const SectionTable = ({ title, rows }) => (
  <div className="overflow-hidden rounded-lg shadow mb-8">
    <table className="w-full text-left bg-white">
      <thead className="bg-[#34495e] text-white">
        <tr>
          <th className="px-6 py-4" colSpan={2}>
            {title}
          </th>
        </tr>
      </thead>
      <tbody className="text-sm divide-y divide-gray-200">
        {rows.map(([label, value], idx) => (
          <tr key={idx}>
            <td className="font-semibold px-6 py-3 text-[#2c3e50] w-1/3">
              {label}
            </td>
            <td className="px-6 py-3 text-[#34495e]">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const InfoTable = ({ title, rows }) => (
  <div className="overflow-hidden rounded-lg shadow mb-8">
    <table className="w-full text-left bg-white">
      <thead className="bg-[#34495e] text-white">
        <tr>
          <th className="px-6 py-4" colSpan={2}>
            {title}
          </th>
        </tr>
      </thead>
      <tbody className="text-sm divide-y divide-gray-200">
        {rows.map(([label, value], idx) => (
          <tr key={idx}>
            <td className="font-semibold px-6 py-3 text-[#2c3e50] w-1/3">
              {label}
            </td>
            <td className="px-6 py-3 text-[#34495e]">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Inquirydetailstab = ({
  selectedRow,
  setSelectedRow,
  setOpenTab,
  getAllBookings,
  getAllHubsListData,
  setActiveItem,
  rowsPerPage,
  tab,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  let vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  let fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  let transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  let vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
   let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  let profile = JSON.parse(localStorage.getItem("profile"));
  const [activeTab, setActiveTab] = useState(null);
  const [summaryDetails, setSummaryDetails] = useState(null);
  const [bookingId, setBookingId] = useState(null);
  const [vehicleDetails, setVehicleDetials] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [paymentDetailsData, setPaymentDetailsData] = useState(null);
  const [systemUserData, setSystemUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const [bookingComments, setBookingComments] = useState([]);
  const [aiSummarizeLoading, setAiSummarizeLoading] = useState(false);
  const [aiSummarizedResult, setAiSummarizedResult] = useState([]);

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) {
        // setCities(response);
      }
    });
  }, []);

  const getBookingDetail = async (Code) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings?&inquiryCode=${Code}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setBookingId(data?.entities?.rows[0].id);
        setSummaryDetails(data?.entities?.rows[0]);
        getVehicleDetial(data?.entities?.rows[0].vehicleId);
        paymentDetails(data?.entities?.rows[0].id);
        fareBreakUpDetails(data?.entities?.rows[0].id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getVehicleDetial = async (vehicleId) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles/${vehicleId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setVehicleDetials(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const fareBreakUpDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingtransactions?bookingId=${bookingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTransactionDetails(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Payment Details:", error);
    }
  };

  const paymentDetails = async (bookingId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings/${bookingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data) {
        setPaymentDetailsData(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Payment Details:", error);
    }
  };

  useEffect(() => {
    if (selectedRow?.inquiryID) {
      getBookingDetail(selectedRow?.inquiryID);
    }
  }, [selectedRow]);

  const getTabs = () => {
    const status = summaryDetails?.bookingStatus;

    let tabs = [];

    if (
      String(status) === fleetBookingStatus?.inverted?.inquiry ||
      String(status) === fleetBookingStatus?.inverted?.paymentPending
    ) {
      tabs.push(
        ...(actionsToAccess?.includes("Initiate Booking")
          ? [
              { id: "updatedetails", label: "Update Details" },
              { id: "assignsalesagent", label: "Assign Sales Agent" },
              { id: "initiatebooking", label: "Initiate Booking" },
              { id: "bookingcomments", label: "Booking Comments" },
              { id: "customer", label: "Customer" },
            ]
          : []),
      );
    }
    if (String(status) === fleetBookingStatus?.inverted?.inquiryClosed) {
      tabs.push(
        ...(actionsToAccess?.includes("Initiate Booking")
          ? [
              { id: "bookingcomments", label: "Booking Comments" },
              { id: "customer", label: "Customer" },
            ]
          : []),
      );
    }
    if (String(status) === fleetBookingStatus?.inverted?.bookingConfirmed) {
      tabs.push();
    }
    return tabs;
  };

  useEffect(() => {
    const tabs = getTabs();
    if (tabs.length > 0) {
      setActiveTab(tabs[0].id); // ✅ set to first available tab
    }
  }, [summaryDetails]); // depends on booking status

  const ageInDays = useMemo(() => {
    if (!summaryDetails?.createdAt) return null;
    return moment().diff(moment(summaryDetails.createdAt), "days");
  }, [summaryDetails?.createdAt]);

  const getBookingComments = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingcomments?limit=1000&bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const sorted = data?.entities?.rows.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt), // oldest → newest
        );
        setBookingComments(sorted);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const getAISummarizedResultAPI = async () => {
    if (bookingComments.length > 0) {
      setAiSummarizeLoading(true);
      try {
        const response = await fetch(
          `${apiUrl}/api/aiserverless/summarize-booking-comments`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              commentArrays: bookingComments || [],
            }),
          },
        );

        if (!response.ok) {
          toast.error("Current Wnet Down please try again later");
          setAiSummarizeLoading(false);
        }

        const data = await response.json();

        if (data?.statusCode === "0100") {
          setAiSummarizedResult(data?.dataValues);
        } else {
          toast.error(data?.msg);
        }

        return data;
      } catch (error) {
        console.error("Error fetching AI summary:", error);
      } finally {
        setAiSummarizeLoading(false);
      }
    } else {
      toast.error("No Booking Comments is available");
    }
  };

  useEffect(() => {
    if (bookingId) {
      getBookingComments(bookingId);
    }
  }, [bookingId]);

  // useEffect(() => {
  //   if (bookingComments) {
  //     getAISummarizedResultAPI();
  //   }
  // }, [bookingComments]);

  return (
    <div>
      <div className="max-w-screen-2xl mx-auto p-4 min-h-screen text-gray-900">
        {/* Header */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-700 text-white p-6 rounded-t-2xl flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shadow-lg">
          <div>
            <h1 className="text-2xl font-bold">
              {selectedRow?.bookingCode ? "Booking" : "Inquiry"} Details -{" "}
              {selectedRow?.bookingCode
                ? selectedRow?.bookingCode
                : summaryDetails?.inquiryCode}{" "}
              {ageInDays !== null && (
                <span className="ml-2 text-sm font-normal opacity-80">
                  ({ageInDays} days ago)
                </span>
              )} <br/>
              Booking Type -{" "}
              {bookingTypes[summaryDetails?.bookingType] ||
                bookingTypes[bookingTypes?.inverted?.dailyRental]}{" "}
              <br />
            </h1>
            <p className="text-sm opacity-80">
              Created on {formatDateAndTime(summaryDetails?.createdAt) || "N/A"}
            </p>
          </div>
          <div className="flex gap-3 flex-wrap">
            <button
              onClick={() => {
                getBookingDetail(selectedRow?.inquiryID);
              }}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center transition duration-300 transform hover:scale-105 active:scale-95"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 30 30"
                className="w-8 h-8"
              >
                <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
              </svg>
            </button>

            <button
              onClick={() => {
                setOpenTab(false);
                getAllBookings(0, rowsPerPage, true);
              }}
              className="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
              type="button"
            >
              <div className="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1024"
                  height="25px"
                  width="25px"
                >
                  <path
                    d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                    fill="#000000"
                  ></path>
                  <path
                    d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                    fill="#000000"
                  ></path>
                </svg>
              </div>
              <p className="translate-x-2">Go Back</p>
            </button>
          </div>
        </div>

        {loading ? (
          <>
            <div className="flex flex-col items-center h-40 justify-center">
              <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
            </div>
          </>
        ) : (
          <>
            {" "}
            <div>
              <Summary
                paymentDetailsData={paymentDetailsData}
                vehicleDetails={vehicleDetails}
                summaryDetails={summaryDetails}
                from="inquiry"
                getAllHubsListData={getAllHubsListData}
                systemUserData={systemUserData}
                setSystemUserData={setSystemUserData}
                setActiveItem={setActiveItem}
                getAISummarizedResultAPI={getAISummarizedResultAPI}
                aiSummarizeLoading={aiSummarizeLoading}
                aiSummarizedResult={aiSummarizedResult}
              />
            </div>
            <div className="flex py-4">
              <div className="p-3 bg-gray-100 border-r border-gray-300">
                {getTabs().map((tab) => (
                  <div
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`cursor-pointer px-2 py-3 font-semibold border-l-4 ${
                      activeTab === tab.id
                        ? "bg-blue-100 border-blue-600 text-blue-600"
                        : "border-transparent text-gray-600 hover:bg-blue-50"
                    }`}
                  >
                    {tab.label}
                  </div>
                ))}
              </div>

              <div className="flex-1 bg-white p-4 shadow-xl rounded-r-2xl">
                {activeTab === "updatedetails" && (
                  <div>
                    <Updatedetails
                      summaryDetails={summaryDetails}
                      getBookingDetail={getBookingDetail}
                    />
                  </div>
                )}
                {activeTab === "assignsalesagent" && (
                  <div>
                    <Assignsalesagent
                      summaryDetails={summaryDetails}
                      getBookingDetail={getBookingDetail}
                      selectedRow={selectedRow}
                    />
                  </div>
                )}
                {activeTab === "initiatebooking" && (
                  <div>
                    <Initiatebooking
                      paymentDetailsData={paymentDetailsData}
                      vehicleDetails={vehicleDetails}
                      summaryDetails={summaryDetails}
                      setActiveTab={setActiveTab}
                      setOpenTab={setOpenTab}
                      paymentDetails={paymentDetails}
                      fareBreakUpDetails={fareBreakUpDetails}
                      getVehicleDetial={getVehicleDetial}
                      getBookingDetail={getBookingDetail}
                      selectedRow={selectedRow}
                      from="inquiry"
                      setActiveItem={setActiveItem}
                      getAllBookings={getAllBookings}
                      rowsPerPage={rowsPerPage}
                    />
                  </div>
                )}
                {activeTab === "bookingcomments" && (
                  <div>
                    <Comments
                      bookingComments={bookingComments}
                      setBookingComments={setBookingComments}
                      getBookingComments={getBookingComments}
                      summaryDetails={summaryDetails}
                      getAISummarizedResultAPI={getAISummarizedResultAPI}
                    />
                  </div>
                )}
                {activeTab === "customer" && (
                  <div>
                    <Customerdetails
                      summaryDetails={summaryDetails}
                      vehicleDetails={vehicleDetails}
                      getBookingDetail={getBookingDetail}
                      refresh={selectedRow}
                    />
                  </div>
                )}
                {activeTab === "vehicle" && (
                  <div>
                    <div className="p-6">
                      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                        Vehicle Details
                      </h2>

                      <SectionTable
                        title="Basic Information"
                        rows={[
                          [
                            "Registration Number",
                            vehicleDetails?.licensePlate || "N/A",
                          ],
                          ["Make & Model", vehicleDetails?.name || "N/A"],
                          // ["On Boarding Date", "2022"],
                          // ["Color", "Pearl White"],
                          [
                            "Vehicle Type",
                            vehicleBodyType[vehicleDetails?.vehicleBodyType] ||
                              "N/A",
                          ],
                          [
                            "Seating Capacity",
                            `${
                              vehicleDetails?.seater
                                ? vehicleDetails?.seater + " Passengers"
                                : "N/A"
                            }`,
                          ],
                          [
                            "Transmission",
                            transmissionType[
                              vehicleDetails?.transmissionType
                            ] || "N/A",
                          ],
                          [
                            "Fuel Type",
                            fuelType[vehicleDetails?.fuelType] || "N/A",
                          ],
                          [
                            "Current Status",
                            <span
                              className={`${
                                vehicleStatus[vehicleDetails?.status]
                                  ? "bg-green-500 text-white"
                                  : "bg-yellow-100 text-yellow-800"
                              } font-semibold px-2 py-1 rounded`}
                            >
                              {vehicleStatus[vehicleDetails?.status] || "N/A"}
                            </span>,
                          ],
                        ]}
                      />
                    </div>
                  </div>
                )}
                {activeTab === "charges" && (
                  <div>
                    {" "}
                    <div className="p-6">
                      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
                        Charges & Payment Details
                      </h2>

                      <ChargesTable paymentDetailsData={paymentDetailsData} />

                      <InfoTable
                        title="Payment Information"
                        rows={[
                          [
                            "Payment Method",
                            transactionDetails[0]?.paymentMode || "N/A",
                          ],
                          [
                            "Payment Status",
                            <span className="text-green-700 font-semibold">
                              {/* Paid */}
                              N/A
                            </span>,
                          ],
                          ["Transaction ID", "N/A"],
                          [
                            "Payment Date",
                            formatDateAndTime(
                              transactionDetails[0]?.transactionDate,
                            ) || "N/A",
                          ],
                          ["Gateway", "Razorpay"],
                          ["Receipt Number", "N/A"],
                        ]}
                      />
                    </div>
                  </div>
                )}
                {activeTab === "cancel" && (
                  <div>
                    <Cancelbooking
                      paymentDetailsData={paymentDetailsData}
                      vehicleDetails={vehicleDetails}
                      summaryDetails={summaryDetails}
                      getBookingDetail={getBookingDetail}
                      selectedRow={selectedRow}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Inquirydetailstab;
